import React, { useState } from 'react';
import { DesktopMenu } from "../../components/menu/Desktop_Menu/DesktopMenu";
import styled from "styled-components";
import { Button } from "../../components/Button";
import { PrivacyPolicyModal } from "../../components/PrivacyPolicyModal";
import { FlexWrapper } from "../../components/FlexWrapper";
import {Container} from "../../components/container/Container";
import {theme} from "../../styles/Theme";
import {MenuFooter} from "../../components/menu/MenuFooter";
import {font} from "../../styles/Common";
import {S} from './Footer_Styles'
import {Icon} from "../../components/icon/icon";
export const Footer = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <S.Footer>
            <Container>
            <S.FooterWrapper>
                <S.LeftSection>
                    <S.Name>FreshWave Cleaning</S.Name>
                    <S.PhoneNumber>Ph: 04 90 927593</S.PhoneNumber>
                    <Button width={'130px'} height={'35px'} onClick={openModal} borderRadius={'5px'}>Our Privacy Policy</Button>
                    {isModalOpen && <PrivacyPolicyModal closeModal={closeModal} />}
                    <S.IconsRow>
                    <S.IconWrapper href="https://www.facebook.com/profile.php?id=61574539065122&notif_id=1746091942672619&notif_t=page_user_activity&ref=notif#" target="_blank" aria-label="Facebook">
                    <Icon iconId={"facebookSign"}  width="24" height="24" viewBox="0 0 20 33" />
                    </S.IconWrapper>
                    <S.IconWrapper href="https://maps.app.goo.gl/WYtUTb1FF3icPA7t7" target="_blank"
                                   aria-label="Google Reviews">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 533.5 544.3" width="24" height="24">
                            <path fill="#4285F4"
                                  d="M533.5 278.4c0-17.7-1.6-35.4-4.9-52.5H272v99.2h146.9c-6.4 34-25 62.9-53.2 82.1v68.3h85.8c50.1-46.2 81-114.2 81-197.1z"/>
                            <path fill="#34A853"
                                  d="M272 544.3c71.5 0 131.6-23.6 175.4-64.2l-85.8-68.3c-23.9 16.1-54.4 25.3-89.6 25.3-68.9 0-127.2-46.5-148.1-109.2H35.6v68.6c43.5 85.6 133.2 147.8 236.4 147.8z"/>
                            <path fill="#FBBC05"
                                  d="M123.9 327.9c-10.5-31.1-10.5-64.9 0-96l-68.3-68.6C13.3 215.1 0 244.2 0 278.4s13.3 63.3 55.6 115.1l68.3-65.6z"/>
                            <path fill="#EA4335"
                                  d="M272 108.1c37.9-.6 74.2 13.7 101.8 40.1l75.8-75.8C405.7 26.4 340.4 0 272 0 168.8 0 79.1 62.2 35.6 147.8l88.3 68.6c21.1-62.8 79.4-108.3 148.1-108.3z"/>
                        </svg>
                    </S.IconWrapper>
                    </S.IconsRow>
                </S.LeftSection>
                <S.MenuWrapper>
                    <MenuFooter color={'white'}/>
                </S.MenuWrapper>
            </S.FooterWrapper>
                <S.Copyright>© 2024 FreshWave Cleaning, All Rights Reserved.</S.Copyright>
            </Container>
        </S.Footer>
    );
};

